import * as PROJECT_CODE from '../../constants/projectCode';
import firebase from '../../lib/firebase.prod';

const firebaseRef = firebase.database();

export default async function getCoBrokerByUserId(userId) {
	let coBroker = {};

	await firebase
		.database()
		.ref('/kavtek_coBrokers/' + PROJECT_CODE.projectCode)
		.orderByChild('userId')
		.equalTo(userId)
		.once('value', async (snapshot) => {
			let coBrokerObj = snapshot.val();
			if (coBrokerObj) {
				let coBrokerValues = Object.values(coBrokerObj);
				if (coBrokerValues.length > 0) {
					coBroker.numberOfLotsAllowed =
						coBrokerValues[0].numberOfLotsAllowed;
				}
				let coBrokerKeys = Object.keys(coBrokerObj);
				if (coBrokerKeys.length > 0) {
					coBroker.id = coBrokerKeys[0];
				}
			}
		});
	return coBroker;
}
